<template>
    <b-modal
        :id="'add-choose-portfolio-category-modal'"
        :ref="'add-choose-portfolio-category-modal'"
        :title="$t('portfolio.add_category')"
        size="lg"
        hide-footer
        modal-class="apprentice-default-modal">
        <div class="assignment-choices">
            <div class="row">
                <div
                    class="col-12 new-assignment"
                    :class="getColWidth()">
                    <div class="add-new-assignment apprentice-simple-card">
                        <div class="new-assignment-icon icon">
                            <i class="btn btn-primary-icon-only btn-add-layer"></i>
                        </div>
                        <div class="new-assignment-content content">
                            <h5 class="title">{{ $t('portfolio.new_category') }}</h5>
                            <div class="description">
                                {{
                                    $t('portfolio.start_with_an_empty_category_as_a_basis_for_creating_a_new_category')
                                }}
                            </div>
                        </div>
                        <a
                            class="clickable"
                            href=""
                            @click.prevent.stop="openNewCategory"></a>
                    </div>
                </div>

                <div
                    class="col-12 existing-assignment"
                    :class="getColWidth()">
                    <div class="new-existing-assignment apprentice-simple-card">
                        <div class="new-existing-assignment-icon icon">
                            <i class="btn btn-primary-icon-only btn-books"></i>
                        </div>
                        <div class="new-assignment-content content">
                            <h5 class="title">{{ $t('portfolio.own_categories') }}</h5>
                            <div class="description">
                                {{
                                    $t(
                                        'portfolio.copy_a_previously_created_category_as_starting_point_for_a_new_category',
                                    )
                                }}
                            </div>
                        </div>
                        <a
                            class="clickable"
                            href=""
                            @click.prevent.stop="copyCategory"></a>
                    </div>
                </div>

                <div
                    class="col-12 col-md-4 col-lg-4 all-existing-assignment"
                    v-if="$authUser.isAdmin()">
                    <div class="new-all-existing-assignment apprentice-simple-card">
                        <div class="new-all-existing-assignment-icon icon">
                            <i class="btn btn-primary-icon-only btn-folders-add"></i>
                        </div>
                        <div class="new-assignment-content content">
                            <h5 class="title">{{ $t('portfolio.all_categories') }}</h5>
                            <div class="description">
                                {{
                                    $t(
                                        'portfolio.copy_a_previously_created_category_as_starting_point_for_a_new_category',
                                    )
                                }}
                            </div>
                        </div>
                        <a
                            class="clickable"
                            href=""
                            @click.prevent.stop="copyAllCategories"></a>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-edit-add-chose-category-modal-component',
    methods: {
        openNewCategory() {
            this.$bvModal.show('add-portfolio-category-modal');
            this.$bvModal.hide('add-choose-portfolio-category-modal');
        },

        copyCategory() {
            this.$bvModal.show('add-copy-portfolio-category-modal');
            this.$bvModal.hide('add-choose-portfolio-category-modal');
        },

        copyAllCategories() {
            this.$bvModal.show('add-all-copy-portfolio-category-modal');
            this.$bvModal.hide('add-choose-portfolio-category-modal');
        },

        getColWidth() {
            if (this.$authUser.isAdmin()) {
                return 'col-md-4 col-lg-4';
            }

            return 'col-md-6 col-lg-6';
        },
    },
};
</script>

<style scoped lang="scss">
.new-assignment,
.existing-assignment,
.all-existing-assignment,
.shared-assignment {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.add-new-assignment,
.new-existing-assignment,
.new-all-existing-assignment,
.new-shared-assignment {
    height: 100%;
    position: relative;
    background-color: $secondary-background-color;

    .icon {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        i {
            font-size: 6rem;
        }
    }

    .content {
        .title {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }

        .description {
            color: $text-muted-color;
        }
    }

    &:hover {
        cursor: pointer;
        box-shadow: 1px 0px 4px $border-color;

        .icon {
            i {
                color: var(--primaryLightest);
            }
        }
    }
}

.assignment-new-name {
    input {
        border: 1px solid $border-color;
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .new-assignment,
    .existing-assignment,
    .all-existing-assignment,
    .shared-assignment {
        margin-bottom: 0;
    }
}
</style>
